import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { GameManager } from "../GameManager";
import { Game } from "../Game";
import { AudioManager } from "../AudioManager";

export class Boot extends Phaser.State {

    public static currentInstance: Boot;

    private static bootedInWrongOrientation: boolean;

    public static enterIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "block";
        document.getElementById("content").style.display = "none";
    }

    public static leaveIncorrectOrientation(): void {

        Game.currentInstance.time.events.add(250, function(): void {

            document.getElementById("orientation").style.display = "none";
            document.getElementById("content").style.display = "block";

            if (Game.currentInstance.device.iOS && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {

                document.getElementById("content").style.height = window.innerHeight.toString() + "px";
                document.getElementById("content").style.width = window.innerWidth.toString() + "px";
    
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
            
            }

        }, Game.currentInstance);

        if (Boot.bootedInWrongOrientation) {

            Boot.bootedInWrongOrientation = false;

            Game.currentInstance.time.events.add(250, function(): void {

                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
            
                GameManager.enterSplashState();
               
            }, GameManager);
        }
    }

    public preload(): void {

        this.load.image("background", "assets/minesweeper_bg.jpg");
        this.load.image("background_shadow", "assets/minesweeper_bg2.png");
        this.load.image("splash", "assets/splash_illustration_big.png");

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            this.load.image("logo-lagged", "assets/logo-lagged.png");
        }
    }

    public init(): void {

        Boot.currentInstance = this;
        Boot.bootedInWrongOrientation = false;

        this.input.maxPointers = 1;

        this.game.stage.disableVisibilityChange = true;

        // por el problema del stock browser
        this.game.stage.backgroundColor = "#FFFFFF";

        this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

        this.game.scale.pageAlignHorizontally = true;
        
        this.game.canvas.oncontextmenu = function (e) { e.preventDefault(); };

        if (this.game.device.desktop) {

            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            this.game.scale.pageAlignHorizontally = true;

            GameVars.scaleY = 1;

        } else {

            this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;

            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            this.game.scale.pageAlignHorizontally = true;

            Boot.bootedInWrongOrientation = window.innerWidth > window.innerHeight;

            this.game.scale.forceOrientation(false, true);
            this.game.scale.enterIncorrectOrientation.add(Boot.enterIncorrectOrientation, Boot);
            this.game.scale.leaveIncorrectOrientation.add(Boot.leaveIncorrectOrientation, Boot);
        }

        this.game.onBlur.add(function(): void {
            AudioManager.mute();
        }, this);

        this.game.onFocus.add(function(): void {
            if (!GameVars.gameData.muted) {
                AudioManager.unMute();
            }
        }, this);
    }

    public create(): void {

        if (!Boot.bootedInWrongOrientation) {
            GameManager.init(this.game);
        }
    }

    public shutdown(): void {

        Boot.currentInstance = null;
        super.shutdown();
    }
}

